import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useFinishConsultation = (
  consultationId,
  patientId,
  consultation
) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError("Error while finishing consultation");

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (consultationOutcome) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(`${tenantVal}/consultation`, {
        ...consultation,
        appointment: consultation.appointment
          ? {
              ...consultation.appointment,
              appointmentDate: undefined,
            }
          : undefined,
        endTime: new Date().toISOString(),
        id: consultationId,
        patientId: Number(patientId),
        consultationOutcome: consultationOutcome,
      });
      return response.data;
    },
    onSuccess: () => {
      toast.success("Consultation finished successfully");
      queryClient.invalidateQueries();
    },
    onError: handleNetworkError,
  });
};
